import { secondsToHms } from "@audacia-hq/shared/utils";
import Link from "next/link";
import * as React from "react";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  optimalMinutes: number;
  remainingTime: number;
  className?: string;
}
const CreditLowWarning: React.FC<Props> = ({
  optimalMinutes, remainingTime, className,
}) => {
  const { t } = useTranslation("consultations");

  const remaining = secondsToHms(remainingTime || 0);

  return (
    <>
      <div className={`flex flex-col text-sm p-6 bg-slate-100 rounded-sm gap-3 ${className}`}>
        <div className="flex flex-col gap-4 text-center">
          <div>
            <Trans
              i18nKey="consultationForm.creditNotice.remainingTime"
              ns="consultations"
              components={[
                <span
                  className="font-semibold"
                  dangerouslySetInnerHTML={{ __html: remaining.toTimeString(t) }}
                />,
              ]}
            />
          </div>

          <div>
            <Trans
              i18nKey="consultationForm.creditNotice.lowCredit.text"
              ns="consultations"
              values={{
                optimalMinutes,
              }}
              components={[
                <span className="font-semibold" />,
              ]}
            />

          </div>
        </div>
        <Link href="/packs" className="text-center underline">
          {t("consultationForm.creditNotice.topUp")}
        </Link>
      </div>
    </>
  );
};

export default CreditLowWarning;
